/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthAdditionalDocumentCategory } from './PalReauthAdditionalDocumentCategory';
import {
    PalReauthAdditionalDocumentCategoryFromJSON,
    PalReauthAdditionalDocumentCategoryFromJSONTyped,
    PalReauthAdditionalDocumentCategoryToJSON,
    PalReauthAdditionalDocumentCategoryToJSONTyped,
} from './PalReauthAdditionalDocumentCategory';

/**
 * 
 * @export
 * @interface PalReauthAdditionalDocumentCreateRequest
 */
export interface PalReauthAdditionalDocumentCreateRequest {
    /**
     * 
     */
    category: PalReauthAdditionalDocumentCategory;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    s3_key: string;
}



/**
 * Check if a given object implements the PalReauthAdditionalDocumentCreateRequest interface.
 */
export function instanceOfPalReauthAdditionalDocumentCreateRequest(value: object): value is PalReauthAdditionalDocumentCreateRequest {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function PalReauthAdditionalDocumentCreateRequestFromJSON(json: any): PalReauthAdditionalDocumentCreateRequest {
    return PalReauthAdditionalDocumentCreateRequestFromJSONTyped(json, false);
}

export function PalReauthAdditionalDocumentCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthAdditionalDocumentCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'category': PalReauthAdditionalDocumentCategoryFromJSON(json['category']),
        'name': json['name'],
        's3_key': json['s3_key'],
    };
}

export function PalReauthAdditionalDocumentCreateRequestToJSON(json: any): PalReauthAdditionalDocumentCreateRequest {
    return PalReauthAdditionalDocumentCreateRequestToJSONTyped(json, false);
}

export function PalReauthAdditionalDocumentCreateRequestToJSONTyped(value?: PalReauthAdditionalDocumentCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': PalReauthAdditionalDocumentCategoryToJSON(value['category']),
        'name': value['name'],
        's3_key': value['s3_key'],
    };
}

